import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ResponsiveDrawer from "../components/ResponsiveDrawer";

import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  TableBody,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Modal,
  LinearProgress,
  IconButton,
  colors,
} from "@mui/material";
import { MdCheckCircle } from "react-icons/md";

import { makeStyles } from "@material-ui/core";
import { Redirect } from "react-router-dom";
import { red } from "@mui/material/colors";
import { Bloodtype } from "@mui/icons-material";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",

    "& .MuiFormHelperText-root": {
      color: "#FF0000 !important",
    },
  },
  toolbar: {
    height: "64px",
  },
  field: {
    ["& fieldset"]: {
      borderRadius: 10,
    },
  },
});

function Paiement(props) {
  const classes = useStyles();

  const [codeCarlo, setCodeCarlo] = useState("");
  const [montant, setMontant] = useState();
  const [pendingRequest, setPendingRequest] = useState([]);
  const [isPendingRequest, setIsPendingRequest] = useState(false);

  const [openWait, setOpenWait] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [codeCarloError, setcodeCarloError] = useState("");
  const [montantError, setMontantError] = useState("");

  useEffect(() => {
    const requestDataPayment = async () => {
      const dataPayment = await fetch(
        "https://bck-aix-en-provence.carloapp.com/api/business/pending_payment_requests",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Version: "4.0",
            Authorization: `Bearer ${props.token}`,
          },
        }
      );
      const body = await dataPayment.json();
      if (body.data.length > 0) {
        setIsPendingRequest(true);
        setPendingRequest(body.data);
      }
    };
    requestDataPayment();
  }, []);

  const paymentRequest = async () => {
    if (!codeCarlo) {
      setcodeCarloError("L'e-mail du client est requis");
      return false;
    }

    if (!montant) {
      setMontantError("Le montant est requis");
      return false;
    }
    setOpenWait(true);
    const dataRequest = await fetch(
      `https://bck-aix-en-provence.carloapp.com/api/business/send_payment_request?referral_code=${codeCarlo}&amount=${montant}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Version: "4.0",
          Authorization: `Bearer ${props.token}`,
        },
      }
    );
    const body = await dataRequest.json();
    setOpenWait(false);
    setOpenSuccess(true);
    // console.log(">>body req", body);
  };

  const listPendingRequest = pendingRequest.map((request, i) => {
    return (
      <TableBody>
        <TableRow key={i}>
          <TableCell>{request.user_name}</TableCell>
          <TableCell>{request.amount}</TableCell>
          <TableCell>{request.created_at}</TableCell>
        </TableRow>
      </TableBody>
    );
  });

  // Redirect user if not logged in
  const isLoggedIn = localStorage.getItem("token");
  // console.log(">>local storage", isLoggedIn);
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    props.onSetToken(isLoggedIn);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <ResponsiveDrawer />
      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        <div>
          <Grid
            container
            sx={{
              display: "flex",
            }}
          >
            <Grid mt={5} item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              >
                Demander un paiement
              </Typography>
            </Grid>
            <Grid
              mt={2}
              item
              xs={12}
              sm={6}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Paper className="paper" sx={{ borderRadius: "10px" }}>
                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
                  Envoyer une demande de paiement
                </Typography>
                <Box mt={2} sx={{ display: "flex", flexDirection: "column" }}>
                  <TextField
                    required
                    autoFocus
                    className={classes.field}
                    label="Code carlo ou adresse mail du client"
                    margin="normal"
                    onChange={(e) => setCodeCarlo(e.target.value)}
                    helperText={codeCarloError}
                    value={codeCarlo}
                  />
                  <TextField
                    required
                    className={classes.field}
                    margin="normal"
                    label="Montant"
                    onChange={(e) => setMontant(e.target.value)}
                    helperText={montantError}
                    autoFocus
                    value={montant}
                  />
                </Box>
                <Box
                  mt={3}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    variant="contained"
                    onClick={() => paymentRequest()}
                    sx={{
                      bgcolor: "#006EFF",
                      ":hover": {
                        bgcolor: "#006EFF",
                      },
                    }}
                  >
                    Demander un paiement{" "}
                  </Button>
                </Box>
              </Paper>

              {/* Modal to show progress/wait */}

              <Modal open={openWait}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <LinearProgress />
                </Box>
              </Modal>

              {/* Modal to show that the transaction payment success was sent with success */}

              <Modal open={openSuccess}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "#fff",
                    p: 4,
                    borderRadius: 5,
                  }}
                >
                  <IconButton color="primary" className={classes.icon}>
                    <MdCheckCircle className={classes.icon} />
                  </IconButton>
                  <Typography mb={2}>
                    Demande de paiement envoyée avec succès
                  </Typography>

                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => setOpenSuccess(false)}
                  >
                    Fermer
                  </Button>
                </Box>
              </Modal>
            </Grid>
            <Grid mt={2} item xs={12} sm={6}>
              <Paper className="paperpay" sx={{ borderRadius: "10px" }}>
                <Typography
                  mt={1}
                  sx={{ fontWeight: "bold", fontSize: "16px" }}
                >
                  Envoyez des demandes de paiement pour toutes vos ventes à
                  distance et vos livraisons.
                </Typography>
                <Box
                  mt={3}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Box
                    component="img"
                    alt="Component"
                    src="/payment_request_illustration.png"
                  />
                </Box>
              </Paper>
            </Grid>
            <Grid mt={5} item>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", fontSize: "18px" }}
              >
                Demandes en attente
              </Typography>
            </Grid>
            <Grid mt={2} item xs={12}>
              <Paper
                className="paperpaywait"
                sx={{
                  height: "292px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: "10px",
                  bgcolor: "#FFFFFF",
                }}
              >
                {isPendingRequest ? (
                  <Table>
                    {" "}
                    <TableHead>
                      <TableRow>
                        <TableCell>Utilisateur</TableCell>
                        <TableCell>Montant</TableCell>
                        <TableCell>Date</TableCell>
                      </TableRow>
                    </TableHead>
                    {listPendingRequest}
                  </Table>
                ) : (
                  <Box>
                    <Box
                      component="img"
                      alt="Component"
                      src="/no_pending_requests.svg"
                      sx={{ width: "300px", height: "200px" }}
                    />
                    <Typography mt={2} sx={{ color: "#BCBCBC" }}>
                      Vous n'avez pas de demande en attente
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </div>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Paiement);
